export default {"src":"/_next/static/media/hair-dryer.f817d436.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};